// src/i18n/auth.ts —— 06 U-01 / U-16b 新增 key（文案逐字取 06）；errEmail / errPwdRule / totp 亦供 me 域引用（U-13 / U-13b）
export const I18N_AUTH = {
  zh: {
    errEmail: '邮箱格式不正确', errRegFill: '请完整填写邮箱、验证码与密码', errPwdRule: '密码至少 8 位且需同时包含字母和数字',
    pwdRule: '至少 8 位，需包含字母和数字', totp: '动态验证码', termsAgree: '我已阅读并同意《用户协议》《隐私政策》',
    errTerms: '请先阅读并同意用户协议与隐私政策', loginAndBind: '登录并绑定', tgBindEmail: '已有邮箱账号？用邮箱登录并绑定当前 Telegram', inviteFromLink: '已通过推荐链接绑定推荐人，无需填写',
    errTgAuth: 'Telegram 验证失败，请关闭后重新打开小程序', tgBoundOk: '已绑定当前 Telegram',
    errCode: '验证码不正确', errNewPwd: '两次输入的新密码不一致，或不满足至少 8 位且包含字母和数字',
  },
  en: {
    errEmail: 'Invalid email address', errRegFill: 'Please fill in email, code and password', errPwdRule: 'Password must be 8+ characters with letters and numbers',
    pwdRule: 'At least 8 characters, letters and numbers', totp: 'Authenticator code', termsAgree: 'I agree to the Terms and the Privacy Policy',
    errTerms: 'Please accept the Terms and Privacy Policy', loginAndBind: 'Sign in & link', tgBindEmail: 'Have an email account? Sign in and link this Telegram', inviteFromLink: 'Referrer applied from your invite link',
    errTgAuth: 'Telegram verification failed. Close and reopen the app', tgBoundOk: 'This Telegram is now linked',
    errCode: 'Incorrect code', errNewPwd: "Passwords don't match, or aren't 8+ characters with letters and numbers",
  },
} as const;

// 06 全局约定错误码表 1003：errCode 删「（演示码 000000）」后缀（02 §14 找回密码演示码）；06 U-16b：errNewPwd 补字母数字规则（X-24）
export const REWRITES_AUTH = ['errCode', 'errNewPwd'] as const;
